module.exports = __webpack_public_path__ + "img/samolikuvannya.2a6d1309.png";